import createAxiosInstance from './axiosConfig';
import { ComercialDTO } from '../shared/dto/comercialDTO';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/comercialController');

export default class ComercialService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }
  
  async listarTodasComerciaisPorRole() {
    return await this.axios.get(`/listarTodasComerciaisPorRole`);
  };

  async ativarInativarComercial(id: string) {
    return await this.axios.get(`/ativarInativarComercial?id=${id}`);
  };

  async listarComercialPorId(id: string) {
    return await this.axios.get(`/listarComercialPorId?id=${id}`);
  };

  async incluirAlterarComercial(dto: ComercialDTO) {
    return await this.axios.post(`/incluirAlterarComercial`, dto);
  };

  async listarTodasComerciaisAtivas() {
    return await this.axios.get(`/listarTodasComerciaisAtivas`);
  };

public async listarPorMatriz(idMatriz: string | number): Promise<any> {
    return this.axios.get(`/listarPorMatriz?idMatriz=${idMatriz}`);
  }

  async listarComerciais(page: number, size: number, filters: any) {
    const params = new URLSearchParams();
    
    params.append('page', String(page));
    params.append('size', String(size));

    for (const key in filters) {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    }
    return await this.axios.get(`/listar`, { params });
  };
}